


import SECTION_1676511135550 from
'../dynamic_section/dynamic_2/template_01';






import HelpSection from '../sections/help/template_01';




import "./style.css";


const HelpPage = ()=>{
  
return (
  <div id="helpPage" class="page ">
  
  

  
  < SECTION_1676511135550 desktopToggle={ true }
    mobileToggle={ false } label={ `tnc_title` } id={ `tnc_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } numberOfImage={ 1 } titlePosition={ `start` }/>
  
  
  
  

  
  <HelpSection desktopTitleToggle={ false }
    mobileTitleToggle={ true }  desktopToggle={ true } mobileToggle={
      true }/>
  
  
  

  
</div>
)
}

export default HelpPage;